import bannerStrand from '../../assets/images/Banner_Strand.png'
import usaFlag from '../../assets/images/usa-flag.svg'
import packingSlip from '../../assets/images/PackingSlip/Packing_Slip.png'
import step1 from '../../assets/images/PackingSlip/Step_1.jpg'
import step2 from '../../assets/images/PackingSlip/Step_2.jpg'
import correctConfigInBaggyAndEcoflex from '../../assets/images/PackingSlip/correct_config_in_baggy_and_ecoflex.png'
import correctConfigButtonPress from '../../assets/images/PackingSlip/correct_config_in_baggy_and_ecoflex_with_button_press.png'
import green from '../../assets/images/PackingSlip/Green.png'
import red from '../../assets/images/PackingSlip/Red.png'
import step3 from '../../assets/images/PackingSlip/Step_3.jpg'
import step4 from '../../assets/images/PackingSlip/Step_4.jpg'
import ecoflex2ReturnLabel from '../../assets/images/PackingSlip/Ecoflex_2_Return_Label.png'
import step6 from '../../assets/images/PackingSlip/Step_6.jpg'

export const packingSlipContent = {
    "sys": {
      "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
      {
        "fields": {
          "name": "Packing Slip COVID-19 Vaccine 2023-2024 ",
          "title": "Packing Slip COVID-19 Vaccine 2023-2024 ",
          "slug": "packing-slip",
          "content": {
            "metadata": {
              "tags": [],
              "concepts": []
            },
            "sys": {
              "space": {
                "sys": {
                  "type": "Link",
                  "linkType": "Space",
                  "id": "n9bebhw263o0"
                }
              },
              "id": "3w8GtOxbb70MlfY4PYDFZ",
              "type": "Entry",
              "createdAt": "2023-09-11T19:23:52.310Z",
              "updatedAt": "2023-09-11T19:23:52.310Z",
              "environment": {
                "sys": {
                  "id": "sandbox",
                  "type": "Link",
                  "linkType": "Environment"
                }
              },
              "publishedVersion": 3,
              "revision": 1,
              "contentType": {
                "sys": {
                  "type": "Link",
                  "linkType": "ContentType",
                  "id": "richTextContentPageTemplate"
                }
              },
              "locale": "en-US"
            },
            "fields": {
              "name": "Packing Slip > Rich Text",
              "modules": [
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "5W9v0SUh4KNW5vqa3BKDnb",
                    "type": "Entry",
                    "createdAt": "2023-09-11T19:19:19.970Z",
                    "updatedAt": "2023-09-11T19:19:19.970Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 4,
                    "revision": 1,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "bannerComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Packing Slip > Rich Text > Banner ",
                    "headline": "Packing Slip",
                    "backgroundImage": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "1Px4l8fvDKjBGrRTCqfWrE",
                        "type": "Asset",
                        "createdAt": "2022-12-29T16:44:45.722Z",
                        "updatedAt": "2022-12-29T16:44:45.722Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 5,
                        "revision": 1,
                        "locale": "en-US"
                      },
                      "fields": {
                        "title": "Banner BG strand top right",
                        "description": "Banner BG strand top right",
                        "file": {
                          "url": bannerStrand,
                          "details": {
                            "size": 47693,
                            "image": {
                              "width": 1920,
                              "height": 511
                            }
                          },
                          "fileName": "Banner_BG_strand_right.png",
                          "contentType": "image/png"
                        }
                      }
                    },
                    "message": "Moderna COVID-19 Vaccine 2023-2024 Formula",
                    "country": {
                      "metadata": {
                        "tags": [],
                        "concepts": []
                      },
                      "sys": {
                        "space": {
                          "sys": {
                            "type": "Link",
                            "linkType": "Space",
                            "id": "n9bebhw263o0"
                          }
                        },
                        "id": "7sht7920U6vs3CLH2CUyaa",
                        "type": "Entry",
                        "createdAt": "2023-05-18T03:23:50.744Z",
                        "updatedAt": "2023-05-24T22:55:23.250Z",
                        "environment": {
                          "sys": {
                            "id": "sandbox",
                            "type": "Link",
                            "linkType": "Environment"
                          }
                        },
                        "publishedVersion": 6,
                        "revision": 2,
                        "contentType": {
                          "sys": {
                            "type": "Link",
                            "linkType": "ContentType",
                            "id": "country"
                          }
                        },
                        "locale": "en-US"
                      },
                      "fields": {
                        "name": "United States",
                        "isocode": "US",
                        "flag": {
                          "metadata": {
                            "tags": [],
                            "concepts": []
                          },
                          "sys": {
                            "space": {
                              "sys": {
                                "type": "Link",
                                "linkType": "Space",
                                "id": "n9bebhw263o0"
                              }
                            },
                            "id": "3aYCbZJiL8aoEKRdhjOXyy",
                            "type": "Asset",
                            "createdAt": "2023-05-24T22:54:50.939Z",
                            "updatedAt": "2023-05-24T22:54:50.939Z",
                            "environment": {
                              "sys": {
                                "id": "sandbox",
                                "type": "Link",
                                "linkType": "Environment"
                              }
                            },
                            "publishedVersion": 5,
                            "revision": 1,
                            "locale": "en-US"
                          },
                          "fields": {
                            "title": "usa flag",
                            "description": "USA Flag",
                            "file": {
                              "url": usaFlag,
                              "details": {
                                "size": 2487,
                                "image": {
                                  "width": 36,
                                  "height": 26
                                }
                              },
                              "fileName": "usa_flag.svg",
                              "contentType": "image/svg+xml"
                            }
                          }
                        },
                        "locales": [
                          "en-US"
                        ]
                      }
                    }
                  }
                },
                {
                  "metadata": {
                    "tags": [],
                    "concepts": []
                  },
                  "sys": {
                    "space": {
                      "sys": {
                        "type": "Link",
                        "linkType": "Space",
                        "id": "n9bebhw263o0"
                      }
                    },
                    "id": "3pnvYtEnaKNC1tu0vGDaHy",
                    "type": "Entry",
                    "createdAt": "2023-09-11T19:23:38.397Z",
                    "updatedAt": "2024-08-02T16:13:57.929Z",
                    "environment": {
                      "sys": {
                        "id": "sandbox",
                        "type": "Link",
                        "linkType": "Environment"
                      }
                    },
                    "publishedVersion": 28,
                    "revision": 3,
                    "contentType": {
                      "sys": {
                        "type": "Link",
                        "linkType": "ContentType",
                        "id": "richTextContentComponent"
                      }
                    },
                    "locale": "en-US"
                  },
                  "fields": {
                    "title": "Packing Slip > Rich Text > Rich Text  ",
                    "content": {
                      "nodeType": "document",
                      "data": {},
                      "content": [
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "RECEIVING & UNPACKING STEPS",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "1. ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "IMMEDIATELY",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " open the cooler.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "If your cooler is an EcoFlex, go to step 2.  ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "If your cooler is a KT91, go to step 3.  ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "2. ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Locate the slip",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " in your package marked “Instructions for Reading the Temperature Monitoring Device in Your Package” and follow the instructions. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "3. ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Compare your packing slip",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " (see example below) to the contents of the cooler to confirm they match.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "4. ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Inspect the vaccines and report any issues",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " (e.g., broken seal) to our WeCare Team at 1-866-MODERNA (1-866-663-3762).",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "5. ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Place vaccines",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " in appropriate storage upon receipt, per package label.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "6. ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Repack and return ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "EcoFlex cooler and temperature monitoring device to your regular UPS pick-up person or call 1-800-PICK-UPS to schedule a pickup from your location. (Instructions on returning your box can be found below.) \n",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "Note: If you receive a KT91 shipper, it will not include a temperature monitoring device, and you may dispose of packing materials.",
                              "marks": [
                                {
                                  "type": "italic"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [
                                {
                                  "type": "italic"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "hr",
                          "data": {},
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "REVIEW YOUR PACKING SLIP ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "6U9UzZAuifs7t5aPhb90H0",
                                "type": "Asset",
                                "createdAt": "2023-09-11T19:20:58.347Z",
                                "updatedAt": "2024-08-02T16:11:48.594Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 26,
                                "revision": 6,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Packing Slip > Review Packing Slip ",
                                "description": "",
                                "file": {
                                  "url": packingSlip,
                                  "details": {
                                    "size": 250425,
                                    "image": {
                                      "width": 1051,
                                      "height": 866
                                    }
                                  },
                                  "fileName": "Packing Slip.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "hr",
                          "data": {},
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "UNPACKING & RETURNING YOUR ECOFLEX SHIPPER. DO NOT DISPOSE!",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Note: The ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "return shipping label ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "can be found on the inside flap of your EcoFlex shipping box. \nFor more information or if you need assistance, contact ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:WeCare@modernatx.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "WeCare@modernatx.com",
                                  "marks": [
                                    {
                                      "type": "underline"
                                    }
                                  ],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": ". ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Step 1",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " - Open shipper and remove the top Koolit PCM gel pack(s).",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "L52Cr4k1rtkRjDu8p5SOr",
                                "type": "Asset",
                                "createdAt": "2023-09-11T19:21:28.106Z",
                                "updatedAt": "2023-09-11T19:21:28.106Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 4,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Packing Slip > Step 1",
                                "description": "",
                                "file": {
                                  "url": step1,
                                  "details": {
                                    "size": 49066,
                                    "image": {
                                      "width": 342,
                                      "height": 281
                                    }
                                  },
                                  "fileName": "Step 1.jpg",
                                  "contentType": "image/jpeg"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Step 2 ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "- Remove the vaccine from the inner box and check the temperature monitoring device.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "5Bx5rNjK0iaiMtHp5LV5xr",
                                "type": "Asset",
                                "createdAt": "2023-09-11T19:21:54.085Z",
                                "updatedAt": "2023-09-11T19:21:54.085Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 4,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Packing Slip > Step 2",
                                "description": "",
                                "file": {
                                  "url": step2,
                                  "details": {
                                    "size": 56915,
                                    "image": {
                                      "width": 342,
                                      "height": 281
                                    }
                                  },
                                  "fileName": "Step 2.jpg",
                                  "contentType": "image/jpeg"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "A. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "On the inside of the lid, you will see a temperature monitoring device. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "7DMKTBph40MSXutGBz0ZpQ",
                                "type": "Asset",
                                "createdAt": "2024-08-02T16:12:24.504Z",
                                "updatedAt": "2024-08-02T16:12:24.504Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 4,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Correct Config Shipper",
                                "description": "",
                                "file": {
                                  "url": correctConfigInBaggyAndEcoflex,
                                  "details": {
                                    "size": 179937,
                                    "image": {
                                      "width": 342,
                                      "height": 342
                                    }
                                  },
                                  "fileName": "correct config in baggy and ecoflex.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "B. Do not remove the temperature monitoring device from its pouch. The device needs to be returned to Moderna within the pouch. ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "On the outside of the plastic pouch,",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " press and hold the START/STOP button for 5 seconds.",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "WimuovbYxTqIzTGi4ryFM",
                                "type": "Asset",
                                "createdAt": "2024-08-02T16:12:49.291Z",
                                "updatedAt": "2024-08-02T16:12:49.291Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 4,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Correct Config Button Press",
                                "description": "",
                                "file": {
                                  "url": correctConfigButtonPress,
                                  "details": {
                                    "size": 204393,
                                    "image": {
                                      "width": 341,
                                      "height": 341
                                    }
                                  },
                                  "fileName": "correct config in baggy and ecoflex with button press.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "C. Keep your finger on the button until the light turns a solid color ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "(approximately 5 seconds).  ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "NOTE:",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " Lights may flash intermittently until a solid color is revealed. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "3UsYjkdyajQF6s9Ez5PVLI",
                                "type": "Asset",
                                "createdAt": "2024-08-02T16:13:19.176Z",
                                "updatedAt": "2024-08-02T16:13:19.176Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 3,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Green Light",
                                "description": "",
                                "file": {
                                  "url": green,
                                  "details": {
                                    "size": 914,
                                    "image": {
                                      "width": 42,
                                      "height": 42
                                    }
                                  },
                                  "fileName": "Green.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "GREEN = Your product is ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "ready for use",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": ". ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "22ih4u8NIdsZEGp6wxhhGI",
                                "type": "Asset",
                                "createdAt": "2024-08-02T16:13:36.960Z",
                                "updatedAt": "2024-08-02T16:13:36.960Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 3,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Red Light",
                                "description": "",
                                "file": {
                                  "url": red,
                                  "details": {
                                    "size": 812,
                                    "image": {
                                      "width": 42,
                                      "height": 42
                                    }
                                  },
                                  "fileName": "Red.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "RED = Please ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "quarantine the product",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " and call 1-866-MODERNA (1-866-663-3762) for further assistance. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "To show the color again after it turns off, press and hold the button again for 1 second. ",
                              "marks": [
                                {
                                  "type": "italic"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Step 3",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " - To return your shipper, first ensure the inner box is placed back inside the EcoFlex shipping system. IMPORTANT: This will help prevent damage during return.",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "M3sgwvMaRDwCr28gA4cu6",
                                "type": "Asset",
                                "createdAt": "2023-09-11T19:22:16.995Z",
                                "updatedAt": "2023-09-11T19:22:16.995Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 3,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Packing Slip > Step 3",
                                "description": "",
                                "file": {
                                  "url": step3,
                                  "details": {
                                    "size": 56849,
                                    "image": {
                                      "width": 342,
                                      "height": 281
                                    }
                                  },
                                  "fileName": "Step 3.jpg",
                                  "contentType": "image/jpeg"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Step 4 ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "- Place the top Koolit PCM gel pack(s) back on top. ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "\n",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "IMPORTANT: This will help prevent damage during return. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "5tUTfyRnTjQdv8ClSQMoyD",
                                "type": "Asset",
                                "createdAt": "2023-09-11T19:22:33.209Z",
                                "updatedAt": "2023-09-11T19:22:33.209Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 4,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Packing Slip > Step 4",
                                "description": "",
                                "file": {
                                  "url": step4,
                                  "details": {
                                    "size": 67704,
                                    "image": {
                                      "width": 342,
                                      "height": 281
                                    }
                                  },
                                  "fileName": "Step 4.jpg",
                                  "contentType": "image/jpeg"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Step 5",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " – Reseal the box by folding in the original outer flaps. Fold in the remaining flaps and ensure the return shipping label is visible. Tape the seam. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "7x2WH3uEpbfVj0nGBa7YEw",
                                "type": "Asset",
                                "createdAt": "2023-09-11T19:22:50.430Z",
                                "updatedAt": "2024-08-02T16:13:55.224Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 8,
                                "revision": 2,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Packing Slip > Step 5",
                                "description": "",
                                "file": {
                                  "url": ecoflex2ReturnLabel,
                                  "details": {
                                    "size": 99304,
                                    "image": {
                                      "width": 342,
                                      "height": 281
                                    }
                                  },
                                  "fileName": "Ecoflex 2 Return Label.png",
                                  "contentType": "image/png"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "Step 6",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " - Give the cooler to your regular delivery person for return. If you do not have regular service, call 1-800-PICK-UPS to schedule a pickup from your location. ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "embedded-asset-block",
                          "data": {
                            "target": {
                              "metadata": {
                                "tags": [],
                                "concepts": []
                              },
                              "sys": {
                                "space": {
                                  "sys": {
                                    "type": "Link",
                                    "linkType": "Space",
                                    "id": "n9bebhw263o0"
                                  }
                                },
                                "id": "3DvnBwCIlz87nQ60Ekjd9p",
                                "type": "Asset",
                                "createdAt": "2023-09-11T19:23:07.608Z",
                                "updatedAt": "2023-09-11T19:23:07.608Z",
                                "environment": {
                                  "sys": {
                                    "id": "sandbox",
                                    "type": "Link",
                                    "linkType": "Environment"
                                  }
                                },
                                "publishedVersion": 3,
                                "revision": 1,
                                "locale": "en-US"
                              },
                              "fields": {
                                "title": "Packing Slip > Step 6",
                                "description": "",
                                "file": {
                                  "url": step6,
                                  "details": {
                                    "size": 21419,
                                    "image": {
                                      "width": 342,
                                      "height": 281
                                    }
                                  },
                                  "fileName": "Step 6.jpg",
                                  "contentType": "image/jpeg"
                                }
                              }
                            }
                          },
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "hr",
                          "data": {},
                          "content": []
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "FOR QUESTIONS ABOUT: ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "unordered-list",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Vaccine temperature excursions after shipment during storage. ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Other vaccine shipment issues (e.g., serialization, shortages, overages, lot number not matching packing slips).",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            },
                            {
                              "nodeType": "list-item",
                              "data": {},
                              "content": [
                                {
                                  "nodeType": "paragraph",
                                  "data": {},
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Modifying or cancelling a future order. ",
                                      "marks": [],
                                      "data": {}
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "CALL 1-866-MODERNA ",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": "(1-866-663-3762)\nHours: Monday - Friday from 8 am - 8 pm EST (Excluding holidays)",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "EMAIL",
                              "marks": [
                                {
                                  "type": "bold"
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            },
                            {
                              "nodeType": "hyperlink",
                              "data": {
                                "uri": "mailto:WeCare@modernatx.com"
                              },
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "WeCare@modernatx.com",
                                  "marks": [],
                                  "data": {}
                                }
                              ]
                            },
                            {
                              "nodeType": "text",
                              "value": " ",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        },
                        {
                          "nodeType": "paragraph",
                          "data": {},
                          "content": [
                            {
                              "nodeType": "text",
                              "value": "LEGAL-US-COV-2400031   07/2024",
                              "marks": [],
                              "data": {}
                            }
                          ]
                        }
                      ]
                    },
                    "printButtonLabel": "Print",
                    "country": "[Circular Reference]"
                  }
                }
              ]
            }
          }
        },
        "sys": {
          "id": "569NITWgRleqOuPaXjITqh",
          "type": "Entry"
        }
      }
    ],
    "includes": {
      "Entry": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ],
      "Asset": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ]
    }
}